import React, { Fragment } from 'react';
import { add as addToCartService } from '../../Services/Cart.service';
import withReactiveStyleBuyButton from './../withReactiveStyleBuyButton';
import { receive, loadError } from '../../Actions/Cart.action';
import { catchError } from '../../Actions/Error.action';
import { useDispatch, useSelector } from 'react-redux';
import { number } from 'prop-types';
import { translate } from '../../Services/translation';
import { addToCartEvent } from '../../Actions/Gtm.action';
const BuyButton = ({
  label,
  articleNumber,
  quantityFieldId,
  articleName,
  articleBrand,
  articleImageUrl,
  minimumQuantity,
  isMinimumQuantity,
  maximumQuantity,
  isMaximumQuantity,
  quantityStepping,
  isQuantityStepping,
  articleStatus,
  isPreorder,
  href,
  cssClass,
  onClick,
  bundles,
  priceTag,
  deliveryDays,
  deliveryText,
  variantId,
  stockBalance,
  sellOverStock
}) => {

  return (
    <Fragment>
      {articleNumber ? (
        <a
          className={cssClass}
          onClick={(e) => {
            e.preventDefault();
            onClick({
              articleNumber,
              quantityFieldId,
              articleName,
              articleBrand,
              articleImageUrl,
              minimumQuantity,
              isMinimumQuantity,
              maximumQuantity,
              isMaximumQuantity,
              quantityStepping,
              isQuantityStepping,
              articleStatus,
              isPreorder,
              bundles,
              priceTag,
              deliveryDays,
              deliveryText,
              variantId,
              stockBalance,
              sellOverStock
            })
          }}
          href={href || '#'}
          rel="nofollow"
        >
          {label}
        </a>
      ) : (
        <a className={cssClass} href={href || '#'} rel="nofollow">
          {label}
        </a>
      )}
    </Fragment>
  );
};
const errorQuantity = (id, errorName) => {
  document.getElementById(id).innerText = errorName;

  return;
};
const StyledButton = (props) => {
  const dispatch = useDispatch();
  const onClick = async ({
    articleNumber,
    quantityFieldId,
    articleName,
    articleBrand,
    articleImageUrl,
    minimumQuantity,
    isMinimumQuantity,
    maximumQuantity,
    isMaximumQuantity,
    quantityStepping,
    isQuantityStepping,
    bundles,
    priceTag,
    deliveryDays,
    deliveryText,
    variantId,
    stockBalance,
    sellOverStock
  }) => {

    try {
      let quantity;
      if (quantityFieldId) {
        quantity = quantityFieldId
          ? document.getElementById(quantityFieldId).value
          : 1;
        var id = 'span-' + quantityFieldId;

        if (
          isMinimumQuantity &&
          isMinimumQuantity.toLowerCase().trim() === 'true' &&
          minimumQuantity &&
          parseInt(quantity) < parseInt(minimumQuantity)
        ) {
          errorQuantity(
            id,
            translate('product.minimumquantity') + ' ' + minimumQuantity
          );
          return false;
        }

        if (
          isMaximumQuantity &&
          isMaximumQuantity.toLowerCase().trim() == 'true' &&
          maximumQuantity &&
          parseInt(quantity) > parseInt(maximumQuantity)
        ) {
          errorQuantity(
            id,
            translate('product.maximumquantity') + ' ' + maximumQuantity
          );
          return false;
        }

        if (
          isQuantityStepping &&
          isQuantityStepping.toLowerCase().trim() === 'true' &&
          quantityStepping &&
          parseInt(quantity) % parseInt(quantityStepping) !== 0
        ) {
          var addQty = parseInt(quantity) % parseInt(quantityStepping);
          errorQuantity(
            id,
            translate('product.multiplequantity') +
            ' ' +
            quantityStepping +
            ' add ' +
            addQty
          );
          return false;
        }
        if (
          sellOverStock &&
          sellOverStock.toLowerCase().trim() === 'false' &&

          parseInt(quantity) > parseInt(stockBalance)
        ) {
          errorQuantity(
            id,
            translate('product.notenoughstock') + ' ' + stockBalance
          );
          return false;
        }
      }

      let cart;
      if (bundles != null && bundles !== undefined && bundles.length > 0) {
        var bundleStringId = bundles[0].bundleId;
        for (const item of bundles) {
          bundleStringId += ';' + item.variant;
        }

        cart = await addToCartService({
          isBundle: true,
          bundleStringId: bundleStringId,
          deliveryDays,
          deliveryText,
        });
      } else {
        cart = await addToCartService({
          articleNumber,
          quantity,
          variantId,
          deliveryDays,
          deliveryText,
        });
      }
      await addToCartEvent(articleNumber, quantity);
      dispatch(receive(cart));

      const productPopup = document.getElementById('popup_box');
      if (productPopup != null) {
        productPopup.classList.add('popup--visible');
        if (
          typeof productPopup.querySelector('.popup__article-title').dataset
            .productName !== 'undefined'
        ) {
          productPopup.querySelector('.popup__article-title').innerText =
            productPopup.querySelector('.popup__article-title').dataset
              .productName +
            ' ' +
            articleName;
        } else {
          let bundlesString = '';
          bundles.forEach((x) => {
            bundlesString += '<br />' + x.quantity + 'x ' + x.variantName;
          });
          productPopup.querySelector('.popup__article-title').innerHTML =
            articleName + bundlesString;
        }
        productPopup.querySelector(
          '.popup__article-number'
        ).innerText = articleNumber;
        productPopup.querySelector(
          '.popup__article-brand'
        ).innerText = articleBrand;
        if (typeof articleImageUrl !== 'undefined' && articleImageUrl !== '') {
          productPopup.querySelector(
            '.popup__article-fig-image'
          ).src = articleImageUrl;
        } else {
          productPopup.querySelector(
            '.popup__article-fig-image'
          ).src = document.querySelector('.thumb.selected img').src;
        }
        if (typeof priceTag !== 'undefined') {
          productPopup.querySelector(
            '.popup__article-price'
          ).innerHTML = priceTag;
        } else {
          productPopup.querySelector(
            '.popup__article-price'
          ).innerHTML = document.querySelector(
            '.product-detail__price-info .price'
          ).innerText;
        }
      }
      return true;
    } catch (ex) {
      dispatch(catchError(ex, (error) => loadError(error)));
      return false;
    }
  };
  const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');

  return <Button {...props} />;
};

export default StyledButton;
